// Badge del estado de la venta (completada / cancelada) — presentación compartida del portal.
import { Badge } from '@/kit';
import type { SaleStatus } from '@/api/services/retail-wizard/contract';

/** Las variantes del `Badge` del kit que este badge usa. */
type BadgeVariant = 'success' | 'danger';

const LABEL: Record<SaleStatus, string> = { COMPLETED: 'Completada', CANCELLED: 'Cancelada' };
const VARIANT: Record<SaleStatus, BadgeVariant> = {
    COMPLETED: 'success',
    CANCELLED: 'danger',
};

/**
 * Un estado que el silo sume después rompe la compilación aquí, en vez de caer al default mudo.
 * `size="xs"` es el chip denso del mock, para las filas de tabla donde el badge normal no cabe.
 */
export function SaleStatusBadge({
    status,
    size,
    className,
}: {
    status: SaleStatus;
    size?: 'default' | 'xs';
    className?: string;
}) {
    return (
        <Badge variant={VARIANT[status]} size={size} className={className}>
            {LABEL[status]}
        </Badge>
    );
}
